'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp, _dec3, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _lodash = require('lodash');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactSlidedown = require('react-slidedown');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _ScreenedCompanies = require('./ScreenedCompanies.css');

var _ScreenedCompanies2 = _interopRequireDefault(_ScreenedCompanies);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenedCompanies = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec2 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScreenedCompanies, _Component);

  function ScreenedCompanies(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompanies);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompanies.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompanies)).call(this, props));

    _this.clickShowList = function (sectorCode) {
      /**
       * Update state to show only one list at a time.
       */
      var newState = {};
      if (_this.state.showList === sectorCode) {
        newState.showList = 'none';
      } else {
        newState.showList = sectorCode;
      }
      _this.setState(newState);
    };

    _this.state = {
      // viewMoreProducers: false,
      // viewMoreFinanciers: false,
      // viewMoreConsumers: false,
      //
      showList: 'none'
    };
    return _this;
  }

  (0, _createClass3.default)(ScreenedCompanies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      /**
       * On page load, scroll to top, call API for list of companies.
       */
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.props.companies();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      /**
       * Sort list of companies from API into three lists, then sort by name.
       */
      if (props.result) {
        var companies = {
          p: [],
          f: [],
          c: []
        };

        props.result.forEach(function (item) {
          if (item.is_po_producer) companies.p.push(item);
          if (item.is_po_financier) companies.f.push(item);
          if (item.is_po_consumer) companies.c.push(item);
        });

        var _sorter = function _sorter(a, b) {
          var _a = a.short_name.toLowerCase();
          var _b = b.short_name.toLowerCase();
          return _a.localeCompare(_b);
        };

        ['p', 'f', 'c'].forEach(function (c) {
          companies[c] = companies[c].sort(_sorter);
        });

        this.setState({
          companies: companies
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '4.0rem' },
            loaded: false
          })
        );
      }

      // card configs
      var cardIcons = {
        p: require('../../../static/images/icn-producers.svg'),
        f: require('../../../static/images/icn-banks.svg'),
        c: require('../../../static/images/icn-consumers.svg')
      };

      var cardTitles = {
        p: 'Agricultural commodity producers and traders',
        f: 'Banks and lenders',
        c: 'Major consumer brands'
      };

      var cardText = {
        p: _react2.default.createElement(
          'span',
          null,
          'Companies that produce and trade palm oil, paper/pulp, rubber, timber, cattle, and soy, and have a past record or a significant risk of contributing to deforestation, land grabbing, and human rights abuses.'
        ),
        f: _react2.default.createElement(
          'span',
          null,
          'Financial institutions directly and indirectly involved in underwriting and lending to deforestation-risk producers and traders. These are the publicly listed banks drawn from the platform ',
          _react2.default.createElement(
            _.Link,
            {
              to: _config2.default.links.fAndf,
              title: 'Forests & Finance',
              xstrong: true
            },
            'Forests & Finance'
          ),
          '.'
        ),
        c: _react2.default.createElement(
          'span',
          null,
          'Consumer goods retailers that source palm oil, paper/pulp, rubber, timber, cattle, and soy from deforestation-risk producers and traders and sell it to consumers worldwide.'
        )
      };

      //
      return _react2.default.createElement(
        'section',
        { styleName: 'screened-companies' },
        _react2.default.createElement(
          'div',
          { styleName: 'screened-companies__cards' },
          /* Render three cards as columns */
          ['p', 'f', 'c'].map(function (sectorCode) {
            return _react2.default.createElement(
              'div',
              { styleName: 'screened-companies__card' },
              _react2.default.createElement(
                'div',
                { styleName: 'screened-companies__card-content' },
                _react2.default.createElement('img', {
                  styleName: 'screened-companies__card-icon',
                  src: cardIcons[sectorCode],
                  alt: 'Agricultural commodity producers and traders'
                }),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'screened-companies__card-title' },
                  cardTitles[sectorCode]
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'screened-companies__card-text' },
                  cardText[sectorCode]
                ),
                _react2.default.createElement(
                  'button',
                  {
                    styleName: 'screened-companies__card-btn',
                    onClick: function onClick() {
                      _this2.clickShowList(sectorCode);
                    },
                    title: 'See companies'
                  },
                  'See companies',
                  _react2.default.createElement(_.LinkIcon, {
                    faclass: _this2.state.showList === sectorCode ? 'fa-angle-up' : 'fa-angle-down'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'hidden-md hidden-lg' },
                _react2.default.createElement(
                  _reactSlidedown.SlideDown,
                  null,
                  _this2.state.showList === sectorCode ? _react2.default.createElement(ScreenedCompaniesList, {
                    sectorCode: sectorCode,
                    sectorTitle: cardTitles[sectorCode],
                    companies: _this2.state.companies[sectorCode]
                  }) : null
                )
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'hidden-xs hidden-sm' },
          ['p', 'f', 'c'].map(function (sectorCode) {
            return _react2.default.createElement(
              _reactSlidedown.SlideDown,
              null,
              _this2.state.showList === sectorCode ? _react2.default.createElement(ScreenedCompaniesList, {
                sectorCode: sectorCode,
                sectorTitle: cardTitles[sectorCode],
                companies: _this2.state.companies[sectorCode]
              }) : null
            );
          })
        )
      );
    }
  }]);
  return ScreenedCompanies;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp)) || _class) || _class);
exports.default = ScreenedCompanies;
var ScreenedCompaniesList = (_dec3 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec3(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(ScreenedCompaniesList, _Component2);

  function ScreenedCompaniesList(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompaniesList);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompaniesList.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompaniesList)).call(this, props));

    _this3.getCompanyFlags = function (company, icons) {
      /**
       * Each flags list is a list of lists.
       * Each item in a flags list is a list of three elements.
       * The three elements are the flag code, e.g. is_sy_p,
       * the flag icon, e.g. icons.iconSy,
       * and the flag label, e.g. 'Soy producer'
       * ['is_sy_p', icons.iconSy, 'Soy producer']
       */
      // Get sectors from CompanySectors.json
      var c = _config2.default.companySectors.data[company.company_id];
      var flags = [];

      // Three types of links possible
      if (_this3.props.sectorCode === 'p') {
        if ((0, _lodash.includes)(c, 'is_sy_p')) {
          flags.push(['is_sy_p', icons.iconSy, 'Soy producer']);
        }
        if ((0, _lodash.includes)(c, 'is_bf_p')) {
          flags.push(['is_bf_p', icons.iconBf, 'Cattle producer']);
        }
        if ((0, _lodash.includes)(c, 'is_tb_p')) {
          flags.push(['is_tb_p', icons.iconTb, 'Timber producer']);
        }
        if ((0, _lodash.includes)(c, 'is_rb_p')) {
          flags.push(['is_rb_p', icons.iconRb, 'Rubber producer']);
        }
        if ((0, _lodash.includes)(c, 'is_pp_p')) {
          flags.push(['is_pp_p', icons.iconPp, 'Paper/pulp producer']);
        }
        if ((0, _lodash.includes)(c, 'is_po_p')) {
          flags.push(['is_po_p', icons.iconPo, 'Palm oil producer']);
        }
      }

      if (_this3.props.sectorCode === 'f') {
        flags = [['is_sy_c', icons.iconSyO, 'Soy financier'], ['is_bf_c', icons.iconBfO, 'Cattle financier'], ['is_tb_c', icons.iconTbO, 'Timber financier'], ['is_rb_c', icons.iconRbO, 'Rubber financier'], ['is_pp_c', icons.iconPpO, 'Paper/pulp financier'], ['is_po_c', icons.iconPoO, 'Palm oil financier']];
      }

      if (_this3.props.sectorCode === 'c') {
        if ((0, _lodash.includes)(c, 'is_sy_c')) {
          flags.push(['is_sy_c', icons.iconSyY, 'Soy major consumer brand']);
        }
        if ((0, _lodash.includes)(c, 'is_bf_c')) {
          flags.push(['is_bf_c', icons.iconBfY, 'Cattle major consumer brand']);
        }
        if ((0, _lodash.includes)(c, 'is_tb_c')) {
          flags.push(['is_tb_c', icons.iconTbY, 'Timber major consumer brand']);
        }
        if ((0, _lodash.includes)(c, 'is_rb_c')) {
          flags.push(['is_rb_c', icons.iconRbY, 'Rubber major consumer brand']);
        }
        if ((0, _lodash.includes)(c, 'is_pp_c')) {
          flags.push(['is_pp_c', icons.iconPpY, 'Paper/pulp major consumer brand']);
        }
        if ((0, _lodash.includes)(c, 'is_po_c')) {
          flags.push(['is_po_c', icons.iconPoY, 'Palm oil major consumer brand']);
        }
      }

      return flags;
    };

    _this3.getCompanyLinks = function (company) {
      /**
       * See CompanyLinks.json for shape of links objects.
       */
      // Get links from CompanyLinks.json
      var links = _config2.default.companyLinks.data[company.company_id];

      // Six types of links possible
      var zsl_spott = links ? links.zsl_spott : '';
      var supply_change = links ? links.supply_change : '';
      var banktrack = links ? links.banktrack : '';
      var rspo = links ? links.rspo : '';
      var forest500 = links ? links.forest500 : '';
      var other_link = links ? links.other_link : '';

      return [[zsl_spott, 'ZSL SPOTT'], [supply_change, 'Supply Change'], [banktrack, 'BankTrack'], [rspo, 'RSPO'], [forest500, 'Forest500'], [other_link, 'Other']];
    };

    _this3.state = {};
    return _this3;
  }

  (0, _createClass3.default)(ScreenedCompaniesList, [{
    key: 'render',


    //
    value: function render() {
      var _this4 = this;

      var icons = {
        iconPo: require('../../../static/images/icn-po.svg'),
        iconPp: require('../../../static/images/icn-pp.svg'),
        iconRb: require('../../../static/images/icn-rb.svg'),
        iconTb: require('../../../static/images/icn-tb.svg'),
        iconBf: require('../../../static/images/icn-bf.svg'),
        iconSy: require('../../../static/images/icn-sy.svg'),
        iconPoO: require('../../../static/images/icn-po-o.svg'),
        iconPpO: require('../../../static/images/icn-pp-o.svg'),
        iconRbO: require('../../../static/images/icn-rb-o.svg'),
        iconTbO: require('../../../static/images/icn-tb-o.svg'),
        iconBfO: require('../../../static/images/icn-bf-o.svg'),
        iconSyO: require('../../../static/images/icn-sy-o.svg'),
        iconPoY: require('../../../static/images/icn-po-y.svg'),
        iconPpY: require('../../../static/images/icn-pp-y.svg'),
        iconRbY: require('../../../static/images/icn-rb-y.svg'),
        iconTbY: require('../../../static/images/icn-tb-y.svg'),
        iconBfY: require('../../../static/images/icn-bf-y.svg'),
        iconSyY: require('../../../static/images/icn-sy-y.svg')
      };

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'screened-companies-list' },
        _react2.default.createElement(
          'h2',
          { styleName: 'screened-companies-list__title' },
          this.props.sectorTitle
        ),
        _react2.default.createElement(
          'table',
          { styleName: 'screened-companies-list__table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                'Company'
              ),
              /* Financiers table does not have this column. */
              this.props.sectorCode !== 'f' ? _react2.default.createElement(
                'th',
                null,
                'Deforestation risk commodities'
              ) : null,
              _react2.default.createElement(
                'th',
                null,
                'Research links'
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.props.companies.map(function (company) {
              // get flags and links
              var company_flags = _this4.getCompanyFlags(company, icons);
              var company_links = _this4.getCompanyLinks(company);

              // console.log(company)
              // company_id: "0C00000CEM"
              // is_po_consumer: true
              // is_po_financier: null
              // is_po_producer: true
              // legal_name: "Stora Enso Oyj"
              // primary_symbol: "STERV"
              // short_name: "Stora Enso"
              // version: "120"
              return _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { 'data-label': 'Company' },
                  _react2.default.createElement(
                    _.CompanyProfileModal,
                    { company_id: company.company_id },
                    _react2.default.createElement(
                      'span',
                      { styleName: 'screened-companies-list__company-title' },
                      company.short_name
                    )
                  ),
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'span',
                    { styleName: 'screened-companies-list__subtitle' },
                    company.primary_symbol ? _react2.default.createElement(
                      'span',
                      null,
                      '[',
                      company.primary_symbol,
                      ']'
                    ) : null,
                    '\xA0',
                    company.legal_name ? company.legal_name : null
                  )
                ),
                /* Financiers table does not have this column. */
                _this4.props.sectorCode !== 'f' ? _react2.default.createElement(
                  'td',
                  { 'data-label': 'Commodities' },
                  company_flags.length > 0 ? company_flags.map(function (flag) {
                    return _react2.default.createElement('img', {
                      styleName: 'screened-companies-list__icon',
                      key: flag[0],
                      src: flag[1],
                      alt: flag[2],
                      title: flag[2]
                    });
                  }) : null
                ) : null,
                _react2.default.createElement(
                  'td',
                  { 'data-label': 'Research links' },
                  /* display any research links for the company  */
                  company_links.map(function (e, i) {
                    return e[0].length ? _react2.default.createElement(
                      'div',
                      { key: i, styleName: 'research-link-div' },
                      _react2.default.createElement(
                        _.Link,
                        {
                          to: e[0],
                          title: e[1] + ': ' + company.short_name,
                          xstrong: true
                        },
                        e[1]
                      )
                    ) : null;
                  })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return ScreenedCompaniesList;
}(_react.Component), _class4.propTypes = {
  companies: _react.PropTypes.array,
  sectorCode: _react.PropTypes.string,
  sectorTitle: _react.PropTypes.string
}, _temp2)) || _class3);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompanies/ScreenedCompanies.js
// module id = 1324
// module chunks = 0